var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c(
        "section",
        {
          ref: "coach",
          staticClass: "soc-step-coach sap-card",
          attrs: { "data-testid": "soc-step-coach" }
        },
        [
          _c("div", { staticClass: "soc-step-coach__badge" }, [
            _vm._v(_vm._s(_vm.badgeText))
          ]),
          _vm._v(" "),
          _c("h3", { staticClass: "soc-step-coach__title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _vm.hint
            ? _c("p", { staticClass: "soc-step-coach__hint" }, [
                _vm._v(_vm._s(_vm.hint))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "soc-step-coach__actions" },
            [
              _vm._t("default", function() {
                return _vm._l(_vm.actions, function(a, i) {
                  return _c(
                    "el-button",
                    {
                      key: a.id || "a-" + i,
                      attrs: {
                        type: a.type || (i === 0 ? "primary" : "default"),
                        size: _vm.buttonSize,
                        disabled: !!a.disabled
                      },
                      on: {
                        click: function($event) {
                          return _vm.$emit("action", a)
                        }
                      }
                    },
                    [_vm._v(_vm._s(a.label))]
                  )
                })
              })
            ],
            2
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05e4bfd2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e4bfd2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocStepCoach.vue
// module id = null
// module chunks = 